<script>
	import { useLocation } from "svelte-navigator";

	import { currentPage } from "../stores/pageStore";
	import model from "../stores/modelStore";

	export let pageList = [];

	let pageNumber = 0;

	const location = useLocation();

	$: {
		$currentPage = pageList.find((p) => p.routeId == $location.pathname);
		if ($currentPage) {
			pageNumber = $currentPage ? $currentPage.pageIndex : 0;
		} else {
			$currentPage = pageList[0];
			pageNumber = 0;
		}
	}
</script>

{#if pageList && pageList.length > 0 && ($currentPage.showInTracker || $currentPage.title)}
	<div class="tracker-root no-print">
		{#if $currentPage.showInTracker}
			<div class="row">
				{#each pageList as page}
					{@const visited = page.pageIndex < pageNumber}
					{@const active = page.pageIndex == pageNumber}
					{@const showInTracker =
						(typeof page.showInTracker === "function" && page.showInTracker($model)) ||
						(typeof page.showInTracker !== "function" && page.showInTracker)}

					{#if showInTracker && pageNumber > 0}
						<div class="col" id={page.routeId} class:visited class:active></div>
					{/if}
				{/each}
			</div>
		{/if}

		{#if $currentPage.title}
			<div class="page-title">
				{$currentPage.title.toUpperCase()}
			</div>
		{/if}
	</div>
{/if}

<style>
	.tracker-root {
		padding-top: 16px;
		padding-bottom: 40px;
		margin: 0 13.5px;
	}

	.col {
		height: 6px;
		background-color: #000;
	}

	.col.visited,
	.col.active {
		background-color: var(--color-primary);
	}

	.page-title {
		text-align: center;
		padding-top: 10px;
		color: #222;
		font-size: 11px;
		font-weight: 700;
	}
</style>
